/**
 * PC Collection Data — GraphQL Fetcher
 * Fetches ALL products in the current collection with tags.
 * Dispatches 'pc:products-ready' event when done.
 *
 * This file ONLY fetches data. It does NOT modify the UI.
 */
(function () {
  'use strict';

  // ============================================
  // CONFIG
  // ============================================
  var STORE_DOMAIN = 'paulas-choice-prod-india.myshopify.com';
  var STOREFRONT_TOKEN = '95949b608c33d0fb4b28d249408c6bac';
  var API_VERSION = '2026-01';
  var PAGE_SIZE = 250;

  // ============================================
  // Get collection handle from page
  // ============================================
  var sidebarEl = document.querySelector('.pc-filter-sidebar');
  if (!sidebarEl) return;

  var collectionHandle = sidebarEl.dataset.collectionHandle;
  if (!collectionHandle) return;

  // ============================================
  // GraphQL Query
  // ============================================
  function buildQuery(cursor) {
    var after = cursor ? ', after: "' + cursor + '"' : '';
    return {
      query:
        '{ collection(handle: "' +
        collectionHandle +
        '") { products(first: ' +
        PAGE_SIZE +
        after +
        ') { edges { node { id handle title tags } cursor } pageInfo { hasNextPage endCursor } } } }',
    };
  }

  // ============================================
  // Fetch all products
  // ============================================
  async function fetchAll() {
    var products = [];
    var cursor = null;
    var hasNext = true;

    while (hasNext) {
      try {
        var res = await fetch(
          'https://' + STORE_DOMAIN + '/api/' + API_VERSION + '/graphql.json',
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN,
              Accept: 'application/json',
            },
            body: JSON.stringify(buildQuery(cursor)),
          },
        );

        var data = await res.json();

        if (data.errors) {
          console.error('[PC Data] GraphQL errors:', data.errors);
          break;
        }

        var collection = data.data.collection;
        if (!collection) {
          console.error('[PC Data] Collection not found:', collectionHandle);
          break;
        }

        collection.products.edges.forEach(function (edge) {
          products.push({
            id: edge.node.id.replace('gid://shopify/Product/', ''),
            handle: edge.node.handle,
            title: edge.node.title,
            tags: edge.node.tags,
          });
        });

        hasNext = collection.products.pageInfo.hasNextPage;
        cursor = collection.products.pageInfo.endCursor;
      } catch (err) {
        console.error('[PC Data] Fetch error:', err);
        break;
      }
    }

    return { products: products, totalCount: products.length };
  }

  // ============================================
  // Init
  // ============================================
  fetchAll().then(function (result) {
    window.pcCollectionData = {
      handle: collectionHandle,
      products: result.products,
      totalCount: result.totalCount,
      ready: true,
    };

    document.dispatchEvent(
      new CustomEvent('pc:products-ready', {
        detail: window.pcCollectionData,
      }),
    );
  });
})();
